/* eslint-disable react/jsx-no-bind */
import React, { useState, useImperativeHandle } from 'react';
import { Modal, Stack } from 'glic-ui-components';
import './ContactUs.scss';
import websiteIcon from '../../assets/websiteIcon.png';
import appConstants from '../../utility/appConstants';

const ContactUsModal = ({ setShowModalRef }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  
  useImperativeHandle(setShowModalRef, () => ({
    setModal() {
      setShow(true);
    },
  }));

  return (
    <div className="contactModal">
      <Modal
        title="Contact us"
        show={show}
        onShow={() => {}}
        submitLabel="Close"
        onSubmit={handleClose}
        onHide={handleClose}
        formId="contact-us-form"
      >
        <Stack direction="vertical" spacing={24}>
          <div className="contactUs">
            <div className="d-flex webSupport">
              <div className="support-icon">
                <img src={websiteIcon} height="56px" alt="" />
              </div>
              <div>
                <p className="supportHeader">{appConstants.SUPPORT_WEBSITE}</p>
                <p className="supportText">
                  <span>
                    {appConstants.SUPPORT_TEAM_TEXT}
                    <br />
                    <span className="phone-contact">
                      {appConstants.WEBSITE_CONTACT}
                    </span>
                    {appConstants.CONTACT_TIMING}
                  </span>
                  <br />
                </p>
                <p className="supportText">
                  <span>
                    {appConstants.EMAIL_TEXT}
                    <a href="mailto:enrollmentsupport@glic.com" className="linkText">{appConstants.EMAIL_LINK}</a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Stack>
      </Modal>
    </div>
  );
};
export default ContactUsModal;
